module.exports = __webpack_public_path__ + "img/outlinedPlus.d5825884.svg";